import transformData from "@/player/data-transformation";
import middleware from "./player/middleware";
import createPrestoPlayer from "./player/create";

export const createPlayers = () => {
  jQuery(".presto-player__player").each(function () {
    const $this = jQuery(this);
    if ($this.data("presto-created")) {
      return;
    }
    createPlayer(this);
    $this.data("presto-created", true);
  });
};

export const createPlayer = async (selector) => {
  const $selector = jQuery(selector);
  let config = $selector.data("presto-config");
  config = transformData({ ...(config || {}) });

  // perform any middleware before creating player
  const create = await middleware({ config, $selector });

  // bail if middleware bails
  if (!create) {
    return;
  }

  return createPrestoPlayer({ config, selector });
};

jQuery(createPlayers); // recommended document.ready

window.presto = {
  createPlayer,
  createPlayers,
};
